<template>
    <div class="z-0 flex w-full justify-between">
        <div class="">
            {{ data?.item }}
        </div>
        <span class="bg-brand/75 ml-4 rounded-full px-3 py-0 text-white capitalize">
            {{ data?.unit?.unit }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'MSPriceItem',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>
